export const refs = {
  upBtn: document.querySelector('.btn-up'),
  homeGalleryList: document.querySelector('.gallery-list'),
  headerContainer: document.querySelector('.header-container'),
  movieModal: document.querySelector('[data-modal]'),
  movieModalContainer: document.querySelector('.js-modal-wrap'),
  closeModalBtn: document.querySelector('[data-modal-close]'),
  modal: document.querySelector('[data-modal]'),
  body: document.querySelector('[data-no-scroll]'),
  searchQuery: document.querySelector('.search-input'),
  searchForm: document.getElementById('search-form'),
  backdrop: document.querySelector('.backdrop'),
  teamModal: document.querySelector('[data-team-modal]'),
  closeTeamModalBtn: document.querySelector('[data-team-modal-close]'),
  teamBackdrop: document.querySelector('.team-backdrop'),
  teamModalBtn: document.querySelector('[data-mod]'),
  galleryBgImg: document.querySelector('.gallery-holder'),
  paginationEl: document.getElementById('pagination'),
  closeSignInModal: document.querySelector('.modal-SignIn-close'),
  signInBackdrop: document.querySelector('.signIn'),
  openSignInModal: document.querySelector('.js-signIn'),
  openSignInModalNd: document.querySelector('.signIn-open'),
  openSignUpModal: document.querySelector('.signUp-open'),
  signUpBackdrop: document.querySelector('.signUp'),
  closeSignUpModal: document.querySelector('.modal-signUp-close'),
  formSignIn: document.querySelector('.sign-in'),
  formSignUp: document.querySelector('.sign-up'),
  exitBtn: document.querySelector('[data-target="logout"]'),
  SignInWithGoogle: document.querySelector('.google-button'),
  SignUpWithGoogle: document.querySelector('.button-google'),
  form: document.querySelector('.search'),
  listEl: document.querySelectorAll('.js-btn-list'),
  libraryEl: document.querySelector('.library'),
  library: document.querySelector('.library-btn'),
  linkEl: document.querySelector('.header__link'),
  activeClass: 'nav-list__button--active',
  libraryJs: document.querySelector('.js-library'),
  activeClass: 'nav-list__button--active',
  home: document.querySelector('.js-home'),
  targetsList: {
    home: 'home',
    library: 'library',
  },
  filterByGenres: document.querySelector('.filter-by-genres'),
  filterByLanguage: document.querySelector('.filter-by-lang'),
  filter: document.querySelector('.filter'),
  openFilter: document.querySelector('.filter__btn'),
  closeFilter: document.querySelector('.filter-close'),
  languagesBox: document.querySelector('.languages'),
  watchedBtn: document.querySelector('.button-watched'),
  queuedBtn: document.querySelector('.button-queue'),
  galleryContainer: document.querySelector('.gallery-holder'),
  homeBtn: document.querySelector('.js-home'),
  ourTeamHead: document.querySelector('.teammate__header'),
  signInTitle: document.querySelector('.signIn-title'),
  signInLabel: document.querySelector('.signIn-label'),
  signInPassword: document.querySelector('.signIn-password'),
  signInSubmitBtn: document.querySelector('.signIn-btn-submit'),
  signInGoogleBtn: document.querySelector('.continue-with'),
  signInNoAcc: document.querySelector('.no-account-desk'),
  signUpTitle: document.querySelector('.SignUp-title'),
  signUpName: document.querySelector('.SignUp-name'),
  signUpEmail: document.querySelector('.SignUp-email'),
  signUpPassword: document.querySelector('.SignUp-password'),
  signUpSubmitBtn: document.querySelector('.SignUp-btn-submit'),
  signUpDesc: document.querySelector('.sign-up-text'),
  swiper: document.querySelector('.swiper'),
  slider: document.querySelector('.swiper-wrapper'),
  exitBtn: document.querySelector('[data-target="logout"]'),
  anonBtn: document.querySelector('.js-anon'),
};
